import { RiEdit2Fill } from "react-icons/ri";
import { FiLogOut } from "react-icons/fi";
import useAuth from "../useAuth";
import userPic from "../assets/user.png";
import { motion } from "framer-motion";
import { FaTasks, FaProjectDiagram } from "react-icons/fa";

export const ProfilePage = () => {
  const { user, logout } = useAuth();

  return (
    <motion.div
      className="max-w-3xl mx-auto p-6"
      initial={{ opacity: 0, y: 24 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.5 }}
    >
      {/* Profile Card */}
      <div className="relative bg-white rounded-3xl shadow-2xl p-8 border border-gray-100 hover:shadow-3xl transition-all duration-300">
        <div className="flex flex-col items-center">
          <img
            src={userPic}
            alt="profile"
            className="h-32 w-32 rounded-full border-4 border-blue-200 object-cover shadow-md"
          />

          <h2 className="text-2xl font-bold mt-4 text-gray-800 tracking-tight">
            {user?.fullName || "User Name"}
          </h2>

          <p className="text-gray-500 mt-1 text-sm capitalize">
            {user?.role || "User Role"}
          </p>

          <div className="mt-4 grid grid-cols-1 gap-2 text-gray-700 text-sm w-full sm:grid-cols-2">
            <p className="flex items-center gap-2">
              📧 <span className="font-medium">Email:</span>{" "}
              <span className="text-gray-600">
                {user?.email || "Not Provided"}
              </span>
            </p>
            <p className="flex items-center gap-2">
              📱 <span className="font-medium">Phone:</span>{" "}
              <span className="text-gray-600">
                {user?.mobileNo || "Not Provided"}
              </span>
            </p>
            <p className="flex items-center gap-2">
              🏷 <span className="font-medium">User Type:</span>{" "}
              <span className="capitalize text-gray-600">
                {user?.userType || "N/A"}
              </span>
            </p>

            <p className="flex items-center gap-2">
              🏬 <span className="font-medium">Organization:</span>{" "}
              <span className="capitalize text-gray-600">
                {user?.organization || "N/A"}
              </span>
            </p>
            <p className="flex items-center gap-2">
              📅 <span className="font-medium">Joined:</span>{" "}
              <span className="text-gray-600">
                {new Date(user?.createdAt).toLocaleDateString("en-IN", {
                  day: "numeric",
                  month: "short",
                  year: "numeric",
                })}
              </span>
            </p>
          </div>

          {/* Actions */}
          <div className="flex gap-4 mt-6">
            <button className="flex items-center gap-2 px-5 py-2 rounded-full bg-blue-600 text-white font-medium hover:bg-blue-700 transition">
              <RiEdit2Fill className="text-xl" />
              Edit Profile
            </button>

            <button
              onClick={logout}
              className="flex items-center gap-2 px-5 py-2 rounded-full bg-red-500 text-white font-medium hover:bg-red-600 transition"
            >
              <FiLogOut className="text-xl" />
              Logout
            </button>
          </div>
        </div>

        {/* Stats Section */}
        <div className="grid grid-cols-2 gap-6 mt-10">
          <div className="flex items-center gap-4 p-4 bg-gradient-to-r from-blue-50 to-blue-100 rounded-xl border border-blue-200 shadow">
            <div className="p-3 bg-blue-500 text-white rounded-full shadow">
              <FaTasks className="text-xl" />
            </div>
            <div>
              <h4 className="text-2xl font-bold text-blue-800">---</h4>
              <p className="text-sm text-blue-700">Projects Completed</p>
            </div>
          </div>

          <div className="flex items-center gap-4 p-4 bg-gradient-to-r from-green-50 to-green-100 rounded-xl border border-green-200 shadow">
            <div className="p-3 bg-green-500 text-white rounded-full shadow">
              <FaProjectDiagram className="text-xl" />
            </div>
            <div>
              <h4 className="text-2xl font-bold text-green-800">---</h4>
              <p className="text-sm text-green-700">Projects Assigned</p>
            </div>
          </div>
        </div>
      </div>
    </motion.div>
  );
};
